// WebRTC baglanti kalitesi ozeti.
//
// Amac teshis dokumu degil, kullaniciya "baglantin zayif" diyebilmek: donma ve
// kopma sikayetlerinde insanlar bugun karsi tarafi sucluyor, cunku ekranda hicbir
// isaret yok. Bu yuzden yalniz uc sinyal okunur - gecikme, paket kaybi ve yolun
// relay (TURN) uzerinden mi gectigi.
//
// Paket kaybi kumulatif sayaclardan OLCUM ARALIGI bazinda hesaplanir: toplam oran,
// basta yasanan bir kaybi gorusme boyunca tasir ve duzelen baglantiyi zayif
// gostermeye devam ederdi.

const POLL_INTERVAL_MS = 3000;

// Esikler ITU-T G.114 (agizdan kulaga 150 ms'e kadar "iyi") ve WebRTC pratiginden:
// %2 kayip goruntude fark edilir, %5 ustu konusmayi bozar.
const FAIR_LOSS_PERCENT = 2;
const POOR_LOSS_PERCENT = 5;
const FAIR_RTT_MS = 200;
const POOR_RTT_MS = 400;

function levelOf(lossPercent, rttMs) {
  if (lossPercent >= POOR_LOSS_PERCENT || rttMs >= POOR_RTT_MS) return 'poor';
  if (lossPercent >= FAIR_LOSS_PERCENT || rttMs >= FAIR_RTT_MS) return 'fair';
  return 'good';
}

function readStats(report) {
  let inbound = null;
  let pair = null;
  const candidates = new Map();

  report.forEach(stat => {
    if (stat.type === 'inbound-rtp' && stat.kind === 'video') {
      inbound = stat;
    } else if (stat.type === 'candidate-pair' && (stat.selected || stat.nominated) && stat.state === 'succeeded') {
      pair = stat;
    } else if (stat.type === 'local-candidate' || stat.type === 'remote-candidate') {
      candidates.set(stat.id, stat);
    }
  });

  return {inbound, pair, candidates};
}

/**
 * `peerConnection` uzerinde duzenli olcum baslatir. Her ornekte `onSample`
 * `{level, rttMs, lossPercent, relay}` ile cagrilir. Donen fonksiyon olcumu durdurur.
 */
export function startConnectionQualityMonitor(peerConnection, onSample) {
  if (!peerConnection || typeof peerConnection.getStats !== 'function') {
    return () => {};
  }

  let previous = null;
  let stopped = false;

  const tick = async () => {
    try {
      const {inbound, pair, candidates} = readStats(await peerConnection.getStats());

      if (stopped) return;

      const received = inbound ? (inbound.packetsReceived || 0) : 0;
      const lost = inbound ? (inbound.packetsLost || 0) : 0;

      let lossPercent = 0;
      if (previous) {
        const deltaReceived = received - previous.received;
        const deltaLost = lost - previous.lost;
        const total = deltaReceived + deltaLost;

        // Aralikta hic paket gelmediyse oran hesaplanamaz; onceki seviye korunur.
        if (total > 0) {
          lossPercent = (deltaLost / total) * 100;
        } else {
          previous = {received, lost};
          return;
        }
      }

      previous = {received, lost};

      const rttMs = pair && pair.currentRoundTripTime ? pair.currentRoundTripTime * 1000 : 0;
      const local = pair ? candidates.get(pair.localCandidateId) : null;
      const remote = pair ? candidates.get(pair.remoteCandidateId) : null;
      const relay = !!(local && local.candidateType === 'relay') || !!(remote && remote.candidateType === 'relay');

      onSample({
        level: levelOf(lossPercent, rttMs),
        rttMs: Math.round(rttMs),
        lossPercent: Math.round(lossPercent * 10) / 10,
        relay
      });
    } catch (error) {
      // Olcum alinamamasi gorusmeyi etkilemez; bir sonraki turda yeniden denenir.
    }
  };

  const handle = setInterval(tick, POLL_INTERVAL_MS);
  tick();

  return () => {
    stopped = true;
    clearInterval(handle);
  };
}

export default startConnectionQualityMonitor;
